export const routeToMailboxIntegrationPage = 'mailbox-integration';
export const routeToMailboxIntegrationLogsPage = 'mailbox-integration-logs';
export const routeToDmsSettingsPage = 'dms-settings';
export const routeToModuleVisibilityPage = 'module-visibility';
export const routeToSharedEmailClient = 'shared-email-client';
export const routeToProductsLinkingPage = 'products';
export const routeToFormsImportDataPage = 'forms-import';
export const routeToFormsCopyDataToProjectsPage = 'forms-copy';
export const routeToDropboxIntegrationPage = 'dropbox-integration';
